import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/cardHeaderStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

type ICardHeaderColor = 'warning' | 'success' | 'danger' | 'info' | 'primary' | 'rose' | 'white';

interface ICardHeader {
	className?: string;
	color?: ICardHeaderColor;
	plain?: boolean;
	image?: boolean;
	contact?: boolean;
	signup?: boolean;
	stats?: boolean;
	icon?: boolean;
	text?: boolean;
	children: string | React.ReactElement;
}

const CardHeader = ({
	className,
	children,
	color,
	plain,
	image,
	contact,
	signup,
	stats,
	icon,
	text,
	...rest
}: ICardHeader) => {
	const classes = useStyles();
	const cardHeaderClasses = classNames({
		[classes.cardHeader]: true,
		[classes[color + 'CardHeader']]: color,
		[classes.cardHeaderPlain]: plain,
		[classes.cardHeaderImage]: image,
		[classes.cardHeaderContact]: contact,
		[classes.cardHeaderSignup]: signup,
		[classes.cardHeaderStats]: stats,
		[classes.cardHeaderIcon]: icon,
		[classes.cardHeaderText]: text,
		[`${className}`]: !!className,
	});
	return (
		<div className={cardHeaderClasses} {...rest}>
			{children}
		</div>
	);
};

export default CardHeader;
